module.exports = __webpack_public_path__ + "img/00000.e51337c5.webp";